import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { errorToast, successToast } from '../Common/showtoast';
import ApiRequest from '../Common/restservice';
import loginbg from '../Assets/Images/loginbg.jpg';
import logo from '../Assets/Images/logo.png';

function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const [theme, setTheme] = useState('light');
    useEffect(() => {
        setTheme(document.body.classList.contains('light-skin') ? "light" : "dark");
        let ele = document.getElementById("root");
        ele.classList.add("h-p100");
        return () => ele.classList.remove("h-p100");
    }, [])
    return (
        <div class="container h-p100" style={{background:`url(${loginbg})`,backgroundSize:'cover',width:'100%',maxWidth:'100%'}}>
            <div class="row align-items-center justify-content-md-center h-p100" style={{backgroundColor:'#efefef4a'}}>
                <div class="col-12">
                    <div class="row justify-content-center g-0">
                        <div class="col-lg-5 col-md-5 col-12">
                            <div class={`${theme==="light" ? "bg-white" : "bg-gray-900"} rounded10 shadow-lg`}>
                                <div class="content-top-agile p-20 pb-0">
                                    <img src={logo} style={{height:60,marginBottom:20}} />
                                    <h2 class="fw-600">Let's Get Started</h2>
                                    <p class="mb-0 text-secondary">Sign in to continue to Happie Marketing.</p>
                                </div>
                                <div class="p-40">
                                    <form onSubmit={async (e) => {
                                        e.preventDefault();
                                        if (!username) {
                                            errorToast("Enter valid username");
                                            return;
                                        } else if (!password) {
                                            errorToast("Enter valid password");
                                            return;
                                        }
                                        let jsoninput = {
                                            username: username,
                                            password: password
                                        }
                                        let res = await ApiRequest("MemberLogin.asp", "POST", jsoninput);
                                        if (res.status === "error") {
                                            errorToast(res.message);
                                            return;
                                        }
                                        localStorage.setItem("username", res.username);
                                        localStorage.setItem("token", res.token);
                                        localStorage.setItem("usertype", res.usertype);
                                        localStorage.setItem("usertypecategory", res.usertypecategory);
                                        navigate("/home");
                                    }}>
                                        <div class="form-group">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text bg-transparent"><i class="text-secondary fa fa-user"></i></span>
                                                <input type="text" placeholder="Enter your account number" onChange={(e) => {
                                                    setUsername(e.target.value);
                                                }} value={username} class="form-control ps-15 bg-transparent" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text  bg-transparent"><i class="text-secondary fa fa-lock"></i></span>
                                                <input type="password" onChange={(e) => {
                                                    setPassword(e.target.value)
                                                }} value={password} class="form-control ps-15 bg-transparent" placeholder="Password" />
                                                <span class="input-group-text  bg-transparent"><i class="text-secondary fa fa-eye"></i></span>
                                                
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="checkbox">
                                                    <input type="checkbox" id="basic_checkbox_1" />
                                                    <label for="basic_checkbox_1">Remember Me</label>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="fog-pwd text-end">
                                                    <Link to={"/forgotpassword"} class="text-secondary fw-500 hover-primary"><i class="ion ion-locked"></i> Forgot password?</Link><br />
                                                </div>
                                            </div>
                                            <div class="col-12 text-center">
                                                <button type="submit" class="btn btn-primary w-p100 mt-10">SIGN IN</button>
                                            </div>
                                        </div>
                                    </form>
                                    <div class="text-center">
                                        <p class="mt-15 mb-0 text-fade">Don't have an account? <Link to={"/register"} class="text-secondary ms-5">Sign Up</Link></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='text-center text-white mt-3'>
                            <Link className=' text-white' to={"/terms"} target='_blank'>Terms & Conditions</Link> ● <Link className=' text-white' to={"/privacypolicy"} target='_blank'>Privacy Policy</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login